<template>
  <header class="settings-header">
    <h2>{{ $t("message.generics.message.settings") }}</h2>
    <i
      v-if="canUseMarketingModule"
      class="mdi mdi-file-download-outline"
      v-tooltip.auto="'Relatório de Marketing'"
      @click="downloadMarketingSimplifiedReport"
    ></i>
  </header>
</template>
<script>
import EventBus from "@packages/event-bus";

export default {
  components: {},

  data() {
    return {};
  },

  computed: {
    userPermissions() {
      return this.$store.state.users.user.permissions;
    },
    canUseMarketingModule() {
      return this.userPermissions.find((x) => x === "USE_MARKETING_MODULE");
    },
  },

  methods: {
    async downloadMarketingSimplifiedReport() {
      try {
        EventBus.$emit("SHOW_SPINNER");

        const xlsFile = await this.$api.marketing.report.getSimpleReport();

        const link = this.createElement(xlsFile);

        link.click();
      } catch (error) {
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    createElement(xlsFile) {
      const url = window.URL.createObjectURL(new Blob([xlsFile]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", "Excel-Relatorio-Marketing.xls");
      document.body.appendChild(link);

      return link;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";
.settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;

  .mdi {
    font-size: 28px;
    color: $grey-6;
    cursor: pointer;
    padding-top: 12px;
  }
}
</style>
